import './SegmentedControl-7f79ab74.css';

var classes = {"SegmentedControl":"prc-SegmentedControl-SegmentedControl-e7570","Item":"prc-SegmentedControl-Item-7Aq6h","Counter":"prc-SegmentedControl-Counter--H-pM","Button":"prc-SegmentedControl-Button-ojWXD","IconButton":"prc-SegmentedControl-IconButton-O80Eh","Content":"prc-SegmentedControl-Content-gnQ4n","Text":"prc-SegmentedControl-Text-c5gSh","LeadingIcon":"prc-SegmentedControl-LeadingIcon-dAHA8"};

export { classes as default };
